module.exports = __webpack_public_path__ + "18e2da920be5acd9a625592c7f3df53e.svg";